export let TicketProviders;
(function (TicketProviders) {
  TicketProviders["EditorList"] = "EditorListTicketProvider";
  TicketProviders["ImageMarkers"] = "EditorImageMarkers";
})(TicketProviders || (TicketProviders = {}));